import {Switch} from '@wandb/weave/components';
import React, {useState} from 'react';

import {
  useMediaDisableVideoStreamDisplay,
  useShouldShowMediaDisableVideoStreamResetAtLevel,
} from '../../hooks';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsContext} from '../contexts/MediaSettingsContextProvider';

export const DisableVideoStream = () => {
  const {updateConfig, unsetConfigField, settingsLevel, panelRef} =
    useMediaSettingsContext();
  const disableVideoStream = useMediaDisableVideoStreamDisplay(
    settingsLevel,
    panelRef
  );
  const isSetAtLevel = useShouldShowMediaDisableVideoStreamResetAtLevel(
    settingsLevel,
    panelRef
  );
  const [shouldDisableVideoStream, setShouldDisableVideoStream] =
    useState(disableVideoStream);
  return (
    <div className="flex justify-between">
      <SettingTitle
        title="Disable video stream"
        configField="disableVideoStream"
        isDirty={isSetAtLevel}
        unsetConfigField={() => unsetConfigField('disableVideoStream')}
      />
      <Switch.Root
        aria-label="Toggle disable video stream"
        data-test="disable-video-stream-switch"
        checked={shouldDisableVideoStream}
        onCheckedChange={newValue => {
          setShouldDisableVideoStream(newValue);
          setTimeout(() => {
            updateConfig({disableVideoStream: newValue});
          }, 100);
        }}>
        <Switch.Thumb checked={shouldDisableVideoStream} />
      </Switch.Root>
    </div>
  );
};
